import { gql } from '@apollo/client';
import { VARIANTS_PACK_FRAGMENT } from '@/contexts/items-context-queries';

export const CREDIT_REQUEST_INVOICE_FRAGMENT = gql`
  fragment CreditRequest_SearchVariantPacksInvoices on VariantPackCreditRequestInvoice {
    available_quantity_for_credit
    id: order_invoice_id
    date
    number: order_invoice_number
    quantity
    unit_price_in_micros
  }
`;

export const CREDIT_REQUEST_UOM_FRAGMENT = gql`
  fragment CreditRequest_SearchOtherUOMs on VariantPackCreditRequestUOM {
    uom
    quantity
  }
`;

export const CREDIT_REQUEST_REASON_FRAGMENT = gql`
  fragment GetCreditRequestReasonFields on credit_request_reasons {
    invoice_required
    request_period_days
    title: display_name
    type
    uuid
  }
`;

export const SEARCH_VP_FOR_CREDIT_REQUEST_QUERY = gql`
  fragment CreditRequestScanScreen_SearchVariantPacksFields on SearchVariantPacksForCreditRequestResponse {
    eligible_for_credit
    guaranteed
    last_fulfillment_date
    variant_pack {
      ...ItemsContext_VariantsPackFields
    }
  }

  query CreditRequestScanScreen_SearchVariantPacks(
    $code: String!
    $locale: String!
    $restaurantUUID: uuid!
    $skipGroupMemberships: Boolean!
    $skipLiveSalt: Boolean!
    $skipSaltApi: Boolean!
    $useSaltCache: Boolean!
    $supplierUUID: uuid!
  ) {
    searchVariantPacksForCreditRequest(
      query: $code
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      ...CreditRequestScanScreen_SearchVariantPacksFields
    }
  }

  ${VARIANTS_PACK_FRAGMENT}
`;

export const SEARCH_VP_FOR_CREDIT_REQUEST_ELIGIBILITY_QUERY = gql`
  fragment CreditRequestPDPScreen_SearchVariantPacksFields on SearchVariantPacksForCreditRequestResponse {
    eligible_for_credit
    guaranteed
  }

  query CreditRequestPDPScreen_SearchVariantPacks(
    $code: String!
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
    $variantPackUUID: uuid
  ) {
    searchVariantPacksForCreditRequest(
      query: $code
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      variant_pack_id: $variantPackUUID
    ) {
      ...CreditRequestPDPScreen_SearchVariantPacksFields
    }
  }

  ${VARIANTS_PACK_FRAGMENT}
`;

export const SEARCH_VP_FOR_CREDIT_REQUEST_BY_INVOICE_QUERY = gql`
  fragment CreditRequestInvoiceItems_SearchVariantPacksFields on SearchVariantPacksForCreditRequestResponse {
    eligible_for_credit
    guaranteed
    variant_pack {
      ...ItemsContext_VariantsPackFields
    }
  }
  query CreditRequestByInvoice_SearchVariantPacks(
    $code: String!
    $locale: String!
    $orderInvoiceUUID: uuid
    $restaurantUUID: uuid!
    $skipGroupMemberships: Boolean!
    $skipLiveSalt: Boolean!
    $skipSaltApi: Boolean!
    $useSaltCache: Boolean!
    $supplierUUID: uuid!
  ) {
    searchVariantPacksForCreditRequest(
      order_invoice_id: $orderInvoiceUUID
      query: $code
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      ...CreditRequestInvoiceItems_SearchVariantPacksFields
    }
  }
  ${VARIANTS_PACK_FRAGMENT}
`;

export const RENDER_PRINT_CREDIT_REQUEST_TEMPLATE_QUERY = gql`
  query CreditRequest_RenderPrintTemplate(
    $creditRequestBatchUUID: uuid!
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    renderPrintCreditRequestTemplate(
      credit_request_batch_id: $creditRequestBatchUUID
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      rendered_template
    }
  }
`;
